import { Component, OnInit } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';

@Component({
  selector: 'matx-notifications2',
  templateUrl: './matx-notifications2.component.html',
  styleUrls: ['./matx-notifications2.component.scss'],
  imports: [MatSidenav]
})
export class MatxNotifications2Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
